export default __webpack_public_path__ + "static/Promo_Desktop-d323b333be01bde46193d31e07f06e14.webp";